<template>
  <div class="ware-house-pc">
    <a-tabs type="card" v-model:activeKey="activeKey" @change="handleActiveChange">
      <a-tab-pane key="FAADQualifiedInvetory" tab="总装调试入库">
        <faad-qualified-invetory v-if="activeKey === 'FAADQualifiedInvetory'"></faad-qualified-invetory>
      </a-tab-pane>
      <a-tab-pane key="fqc" tab="成品">
        <fqc v-if="activeKey === 'fqc'"></fqc>
      </a-tab-pane>
      <a-tab-pane key="inventory" tab="成品库存">
        <fqc-qualified-invetory type="fqc" v-if="activeKey === 'inventory'"></fqc-qualified-invetory>
      </a-tab-pane>
      <a-tab-pane key="oqc" tab="包装">
        <oqc v-if="activeKey === 'oqc'"></oqc>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { defineComponent, provide, ref, watch } from "vue";
import faadQualifiedInvetory from "@/views/productDaily/warehouse/FAADQualifiedInvetory.vue";
import fqc from "@/views/productDaily/warehouse/fqc.vue";
import oqc from "@/views/productDaily/warehouse/oqc.vue";
import fqcQualifiedInvetory from "@/views/productDaily/components/product/components/inventorySF/index.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  components: {
    fqc,
    oqc,
    faadQualifiedInvetory,
    fqcQualifiedInvetory,
  },
  setup() {
    const route = useRoute();
    provide('warehouseEditAuthority', route.meta['/warehouse_edit'] || route.meta['/trail_warehouse_edit']);

    const activeKey = ref("FAADQualifiedInvetory");
    provide("activeKey", activeKey);

    const tabActivekey = ref(null);

    provide("tabActivekey", tabActivekey);

    const produceOrTpc = ref(route.meta.produceOrTpc);

    provide('produceOrTpc', produceOrTpc.value);


    watch(
      () => activeKey.value,
      (val) => {
        tabActivekey.value = val;
        produceOrTpc.value = route.meta.produceOrTpc;
      },
      {
        deep: true,
      }
    );

    return {
      activeKey,
    };
  },
});
</script>

<style lang="less" scoped>
.ware-house-pc {
  width: 100%;
  height: calc(100vh - 110px);
  box-shadow: 0 0 5px 0 #ccc;
  background: #fff;
  border-radius: 20px;
  padding: 20px;

  .space {
    margin-bottom: 10px;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
